import React from 'react';
import PropTypes from 'prop-types';

export default class RawHtml extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    element: PropTypes.string,
    content: PropTypes.string
  };

  componentDidMount() {
    if (window.$WowheadPower) {
      try {
        window.$WowheadPower.refreshLinks();
      } catch (e) {
        // Intentionally blank
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (window.$WowheadPower) {
      try {
        window.$WowheadPower.refreshLinks();
      } catch (e) {
        // Intentionally blank
      }
    }
  }

  componentWillUnmount() {
    if (window.$WowheadPower) {
      try {
        window.$WowheadPower.hideTooltip();
      } catch (e) {
        // Intentionally blank
      }
    }
  }

  render() {
    const {className, content, element = 'div'} = this.props;

    const Component = element;

    return (
      <Component className={className} dangerouslySetInnerHTML={{__html: content}}/>
    );
  }
}



// WEBPACK FOOTER //
// ./components/rawHtml/RawHtml.js